import React, { useMemo } from 'react'
import classNames from 'classnames'
import CustomIcon from '@/components/CustomIcon'
import isBoolean from 'lodash/isBoolean'
import { OPERATION_ICON_MAP } from './constants'

import styles from './index.less'

type IconType =
    | 'fuzhi'
    | 'bianji'
    | 'jiami'
    | 'jiemi'
    | 'shezhi'
    | 'fenxiang'
    | 'shanchu'
    | 'paichu'
    | 'xiang'
    | 'zong'
    | 'huan'
    | 'bu'
    | 'rizhi'
    | 'dayin'
    | 'text'
    | 'xiangNew'
interface CustomOperationIconProps {
    /**
     * @description       自定义图标外容器样式
     * @default           空字符串
     */
    className: string
    /**
     * @description       自定义图标容器样式
     * @default           空字符串
     */
    iconClassName: string
    /**
     * @description       类型[传入组件内规定名称或者IconFont图标名]
     * @default           空字符串
     */
    type: IconType
    /**
     * @description       是否有边框
     * @default           false
     */
    border: boolean
    /**
     * @description       是否有背景
     * @default           true
     */
    bg: boolean
    /**
     * @description       自定义文字（非必填）
     * @default           空字符串
     */
    text: string
}

const CustomOperationIcon = ({
    className,
    iconClassName,
    type,
    border,
    bg = true,
    text = '',
    ...restProps
}: CustomOperationIconProps) => {
    const target = useMemo(() => OPERATION_ICON_MAP[type], [type])
    const currType = target?.type || type || ''
    const currBorder = isBoolean(border) ? border : target?.border || false
    const currBg = isBoolean(bg) ? bg : true
    const currStyle = target?.style || {}
    const currIconProps = {
        className: classNames(styles.icon, iconClassName),
        style: target?.iconStyle || {}
    }
    return (
        <div
            className={classNames(styles.container, className, {
                [styles.boxBorder]: currBorder,
                [styles.boxBg]: currBg
            })}
            style={currStyle}
            {...restProps}
        >
            {currType === 'text' ? (
                <span {...currIconProps}>{text}</span>
            ) : (
                <CustomIcon type={currType} {...currIconProps} />
            )}
        </div>
    )
}
/**
 * 统一悬浮图标
 * @param {CustomOperationIconProps} CustomOperationIconProps 入参对象
 * @returns {React.Node} 返回内容
 * 示例用法
 * - 自定义文案：
 * <CustomOperationIcon type="text" text="详" />
 *
 * - icon图标:
 * [type传入组件内规定名称或者IconFont图标名]
 * <CustomOperationIcon type="bianji" />
 *
 */
export default React.memo(CustomOperationIcon)
